[
    {
        "alpha2": "af",
        "alpha3": "afg",
        "name": "Afganistan"
    },
    {
        "alpha2": "ax",
        "alpha3": "ala",
        "name": "Aland"
    },
    {
        "alpha2": "al",
        "alpha3": "alb",
        "name": "Albania"
    },
    {
        "alpha2": "de",
        "alpha3": "deu",
        "name": "Alemania"
    },
    {
        "alpha2": "ad",
        "alpha3": "and",
        "name": "Andorra"
    },
    {
        "alpha2": "ao",
        "alpha3": "ago",
        "name": "Angola",
        "inactive": true
    },
    {
        "alpha2": "ai",
        "alpha3": "aia",
        "name": "Anguila"
    },
    {
        "alpha2": "aq",
        "alpha3": "ata",
        "name": "Antartida",
        "inactive": true
    },
    {
        "alpha2": "ag",
        "alpha3": "atg",
        "name": "Antigua y Barbuda"
    },
    {
        "alpha2": "sa",
        "alpha3": "sau",
        "name": "Arabia Saudita"
    },
    {
        "alpha2": "dz",
        "alpha3": "dza",
        "name": "Argelia"
    },
    {
        "alpha2": "ar",
        "alpha3": "arg",
        "name": "Argentina"
    },
    {
        "alpha2": "am",
        "alpha3": "arm",
        "name": "Armenia"
    },
    {
        "alpha2": "aw",
        "alpha3": "abw",
        "name": "Aruba",
        "inactive": true
    },
    {
        "alpha2": "au",
        "alpha3": "aus",
        "name": "Australia"
    },
    {
        "alpha2": "at",
        "alpha3": "aut",
        "name": "Austria"
    },
    {
        "alpha2": "az",
        "alpha3": "aze",
        "name": "Azerbaiyan"
    },
    {
        "alpha2": "bs",
        "alpha3": "bhs",
        "name": "Bahamas"
    },
    {
        "alpha2": "bd",
        "alpha3": "bgd",
        "name": "Banglades"
    },
    {
        "alpha2": "bb",
        "alpha3": "brb",
        "name": "Barbados"
    },
    {
        "alpha2": "bh",
        "alpha3": "bhr",
        "name": "Barein"
    },
    {
        "alpha2": "be",
        "alpha3": "bel",
        "name": "Belgica"
    },
    {
        "alpha2": "bz",
        "alpha3": "blz",
        "name": "Belice"
    },
    {
        "alpha2": "bj",
        "alpha3": "ben",
        "name": "Benin"
    },
    {
        "alpha2": "bm",
        "alpha3": "bmu",
        "name": "Bermudas"
    },
    {
        "alpha2": "by",
        "alpha3": "blr",
        "name": "Bielorrusia"
    },
    {
        "alpha2": "bo",
        "alpha3": "bol",
        "name": "Bolivia"
    },
    {
        "alpha2": "bq",
        "alpha3": "bes",
        "name": "Bonaire San Eustaquio y Saba",
        "inactive": true
    },
    {
        "alpha2": "ba",
        "alpha3": "bih",
        "name": "Bosnia y Herzegovina"
    },
    {
        "alpha2": "bw",
        "alpha3": "bwa",
        "name": "Botsuana"
    },
    {
        "alpha2": "br",
        "alpha3": "bra",
        "name": "Brasil"
    },
    {
        "alpha2": "bn",
        "alpha3": "brn",
        "name": "Brunei"
    },
    {
        "alpha2": "bg",
        "alpha3": "bgr",
        "name": "Bulgaria"
    },
    {
        "alpha2": "bf",
        "alpha3": "bfa",
        "name": "Burkina Faso"
    },
    {
        "alpha2": "bi",
        "alpha3": "bdi",
        "name": "Burundi",
        "inactive": true
    },
    {
        "alpha2": "bt",
        "alpha3": "btn",
        "name": "Butan",
        "inactive": true
    },
    {
        "alpha2": "cv",
        "alpha3": "cpv",
        "name": "Cabo Verde",
        "inactive": true
    },
    {
        "alpha2": "kh",
        "alpha3": "khm",
        "name": "Camboya"
    },
    {
        "alpha2": "cm",
        "alpha3": "cmr",
        "name": "Camerun"
    },
    {
        "alpha2": "ca",
        "alpha3": "can",
        "name": "Canada"
    },
    {
        "alpha2": "qa",
        "alpha3": "qat",
        "name": "Catar"
    },
    {
        "alpha2": "td",
        "alpha3": "tcd",
        "name": "Chad"
    },
    {
        "alpha2": "cl",
        "alpha3": "chl",
        "name": "Chile"
    },
    {
        "alpha2": "cn",
        "alpha3": "chn",
        "name": "China"
    },
    {
        "alpha2": "cy",
        "alpha3": "cyp",
        "name": "Chipre"
    },
    {
        "alpha2": "co",
        "alpha3": "col",
        "name": "Colombia"
    },
    {
        "alpha2": "km",
        "alpha3": "com",
        "name": "Comoras",
        "inactive": true
    },
    {
        "alpha2": "kp",
        "alpha3": "prk",
        "name": "Corea del Norte",
        "inactive": true
    },
    {
        "alpha2": "kr",
        "alpha3": "kor",
        "name": "Corea del Sur"
    },
    {
        "alpha2": "ci",
        "alpha3": "civ",
        "name": "Costa de Marfil"
    },
    {
        "alpha2": "cr",
        "alpha3": "cri",
        "name": "Costa Rica"
    },
    {
        "alpha2": "hr",
        "alpha3": "hrv",
        "name": "Croacia"
    },
    {
        "alpha2": "cu",
        "alpha3": "cub",
        "name": "Cuba",
        "inactive": true
    },
    {
        "alpha2": "cw",
        "alpha3": "cuw",
        "name": "Curazao",
        "inactive": true
    },
    {
        "alpha2": "dk",
        "alpha3": "dnk",
        "name": "Dinamarca"
    },
    {
        "alpha2": "dm",
        "alpha3": "dma",
        "name": "Dominica"
    },
    {
        "alpha2": "ec",
        "alpha3": "ecu",
        "name": "Ecuador"
    },
    {
        "alpha2": "eg",
        "alpha3": "egy",
        "name": "Egipto"
    },
    {
        "alpha2": "sv",
        "alpha3": "slv",
        "name": "El Salvador"
    },
    {
        "alpha2": "ae",
        "alpha3": "are",
        "name": "Emiratos Arabes Unidos"
    },
    {
        "alpha2": "er",
        "alpha3": "eri",
        "name": "Eritrea",
        "inactive": true
    },
    {
        "alpha2": "sk",
        "alpha3": "svk",
        "name": "Eslovaquia"
    },
    {
        "alpha2": "si",
        "alpha3": "svn",
        "name": "Eslovenia"
    },
    {
        "alpha2": "es",
        "alpha3": "esp",
        "name": "España"
    },
    {
        "alpha2": "us",
        "alpha3": "usa",
        "name": "Estados Unidos"
    },
    {
        "alpha2": "ee",
        "alpha3": "est",
        "name": "Estonia"
    },
    {
        "alpha2": "et",
        "alpha3": "eth",
        "name": "Etiopia",
        "inactive": true
    },
    {
        "alpha2": "ph",
        "alpha3": "phl",
        "name": "Filipinas"
    },
    {
        "alpha2": "fi",
        "alpha3": "fin",
        "name": "Finlandia"
    },
    {
        "alpha2": "fj",
        "alpha3": "fji",
        "name": "Fiyi"
    },
    {
        "alpha2": "fr",
        "alpha3": "fra",
        "name": "Francia"
    },
    {
        "alpha2": "ga",
        "alpha3": "gab",
        "name": "Gabon"
    },
    {
        "alpha2": "gm",
        "alpha3": "gmb",
        "name": "Gambia",
        "inactive": true
    },
    {
        "alpha2": "ge",
        "alpha3": "geo",
        "name": "Georgia"
    },
    {
        "alpha2": "gh",
        "alpha3": "gha",
        "name": "Ghana"
    },
    {
        "alpha2": "gi",
        "alpha3": "gib",
        "name": "Gibraltar"
    },
    {
        "alpha2": "gd",
        "alpha3": "grd",
        "name": "Granada"
    },
    {
        "alpha2": "gr",
        "alpha3": "grc",
        "name": "Grecia"
    },
    {
        "alpha2": "gl",
        "alpha3": "grl",
        "name": "Groenlandia",
        "inactive": true
    },
    {
        "alpha2": "gp",
        "alpha3": "glp",
        "name": "Guadalupe"
    },
    {
        "alpha2": "gu",
        "alpha3": "gum",
        "name": "Guam"
    },
    {
        "alpha2": "gt",
        "alpha3": "gtm",
        "name": "Guatemala"
    },
    {
        "alpha2": "gf",
        "alpha3": "guf",
        "name": "Guayana Francesa",
        "inactive": true
    },
    {
        "alpha2": "gg",
        "alpha3": "ggy",
        "name": "Guernsey"
    },
    {
        "alpha2": "gn",
        "alpha3": "gin",
        "name": "Guinea",
        "inactive": true
    },
    {
        "alpha2": "gw",
        "alpha3": "gnb",
        "name": "Guinea-Bisau",
        "inactive": true
    },
    {
        "alpha2": "gq",
        "alpha3": "gnq",
        "name": "Guinea Ecuatorial",
        "inactive": true
    },
    {
        "alpha2": "gy",
        "alpha3": "guy",
        "name": "Guyana"
    },
    {
        "alpha2": "ht",
        "alpha3": "hti",
        "name": "Haiti",
        "inactive": true
    },
    {
        "alpha2": "hn",
        "alpha3": "hnd",
        "name": "Honduras"
    },
    {
        "alpha2": "hk",
        "alpha3": "hkg",
        "name": "Hong Kong"
    },
    {
        "alpha2": "hu",
        "alpha3": "hun",
        "name": "Hungria"
    },
    {
        "alpha2": "in",
        "alpha3": "ind",
        "name": "India"
    },
    {
        "alpha2": "id",
        "alpha3": "idn",
        "name": "Indonesia"
    },
    {
        "alpha2": "iq",
        "alpha3": "irq",
        "name": "Irak"
    },
    {
        "alpha2": "ir",
        "alpha3": "irn",
        "name": "Iran",
        "inactive": true
    },
    {
        "alpha2": "ie",
        "alpha3": "irl",
        "name": "Irlanda"
    },
    {
        "alpha2": "bv",
        "alpha3": "bvt",
        "name": "Isla Bouvet",
        "inactive": true
    },
    {
        "alpha2": "im",
        "alpha3": "imn",
        "name": "Isla de Man"
    },
    {
        "alpha2": "cx",
        "alpha3": "cxr",
        "name": "Isla de Navidad",
        "inactive": true
    },
    {
        "alpha2": "is",
        "alpha3": "isl",
        "name": "Islandia"
    },
    {
        "alpha2": "ky",
        "alpha3": "cym",
        "name": "Islas Caiman"
    },
    {
        "alpha2": "cc",
        "alpha3": "cck",
        "name": "Islas Cocos",
        "inactive": true
    },
    {
        "alpha2": "ck",
        "alpha3": "cok",
        "name": "Islas Cook",
        "inactive": true
    },
    {
        "alpha2": "fo",
        "alpha3": "fro",
        "name": "Islas Feroe"
    },
    {
        "alpha2": "gs",
        "alpha3": "sgs",
        "name": "Islas Georgias del Sur y Sandwich del Sur",
        "inactive": true
    },
    {
        "alpha2": "hm",
        "alpha3": "hmd",
        "name": "Islas Heard y McDonald",
        "inactive": true
    },
    {
        "alpha2": "fk",
        "alpha3": "flk",
        "name": "Islas Malvinas",
        "inactive": true
    },
    {
        "alpha2": "mp",
        "alpha3": "mnp",
        "name": "Islas Marianas del Norte",
        "inactive": true
    },
    {
        "alpha2": "mh",
        "alpha3": "mhl",
        "name": "Islas Marshall",
        "inactive": true
    },
    {
        "alpha2": "pn",
        "alpha3": "pcn",
        "name": "Islas Pitcairn",
        "inactive": true
    },
    {
        "alpha2": "sb",
        "alpha3": "slb",
        "name": "Islas Salomon",
        "inactive": true
    },
    {
        "alpha2": "tc",
        "alpha3": "tca",
        "name": "Islas Turcas y Caicos"
    },
    {
        "alpha2": "um",
        "alpha3": "umi",
        "name": "Islas Ultramarinas Menores de los Estados Unidos",
        "inactive": true
    },
    {
        "alpha2": "vg",
        "alpha3": "vgb",
        "name": "Islas Virgenes Britanicas"
    },
    {
        "alpha2": "vi",
        "alpha3": "vir",
        "name": "Islas Virgenes de los Estados Unidos",
        "inactive": true
    },
    {
        "alpha2": "il",
        "alpha3": "isr",
        "name": "Israel"
    },
    {
        "alpha2": "it",
        "alpha3": "ita",
        "name": "Italia"
    },
    {
        "alpha2": "jm",
        "alpha3": "jam",
        "name": "Jamaica"
    },
    {
        "alpha2": "jp",
        "alpha3": "jpn",
        "name": "Japon"
    },
    {
        "alpha2": "je",
        "alpha3": "jey",
        "name": "Jersey"
    },
    {
        "alpha2": "jo",
        "alpha3": "jor",
        "name": "Jordania"
    },
    {
        "alpha2": "kz",
        "alpha3": "kaz",
        "name": "Kazajistan"
    },
    {
        "alpha2": "ke",
        "alpha3": "ken",
        "name": "Kenia"
    },
    {
        "alpha2": "kg",
        "alpha3": "kgz",
        "name": "Kirguistan"
    },
    {
        "alpha2": "ki",
        "alpha3": "kir",
        "name": "Kiribati",
        "inactive": true
    },
    {
        "alpha2": "xk",
        "alpha3": "xkk",
        "name": "Kosovo"
    },
    {
        "alpha2": "kw",
        "alpha3": "kwt",
        "name": "Kuwait"
    },
    {
        "alpha2": "la",
        "alpha3": "lao",
        "name": "Laos"
    },
    {
        "alpha2": "ls",
        "alpha3": "lso",
        "name": "Lesoto",
        "inactive": true
    },
    {
        "alpha2": "lv",
        "alpha3": "lva",
        "name": "Letonia"
    },
    {
        "alpha2": "lb",
        "alpha3": "lbn",
        "name": "Libano",
        "inactive": true
    },
    {
        "alpha2": "lr",
        "alpha3": "lbr",
        "name": "Liberia"
    },
    {
        "alpha2": "ly",
        "alpha3": "lby",
        "name": "Libia",
        "inactive": true
    },
    {
        "alpha2": "li",
        "alpha3": "lie",
        "name": "Liechtenstein"
    },
    {
        "alpha2": "lt",
        "alpha3": "ltu",
        "name": "Lituania"
    },
    {
        "alpha2": "lu",
        "alpha3": "lux",
        "name": "Luxemburgo"
    },
    {
        "alpha2": "mo",
        "alpha3": "mac",
        "name": "Macao"
    },
    {
        "alpha2": "mk",
        "alpha3": "mkd",
        "name": "Macedonia del Norte"
    },
    {
        "alpha2": "mg",
        "alpha3": "mdg",
        "name": "Madagascar"
    },
    {
        "alpha2": "my",
        "alpha3": "mys",
        "name": "Malasia"
    },
    {
        "alpha2": "mw",
        "alpha3": "mwi",
        "name": "Malaui"
    },
    {
        "alpha2": "mv",
        "alpha3": "mdv",
        "name": "Maldivas"
    },
    {
        "alpha2": "ml",
        "alpha3": "mli",
        "name": "Mali"
    },
    {
        "alpha2": "mt",
        "alpha3": "mlt",
        "name": "Malta"
    },
    {
        "alpha2": "ma",
        "alpha3": "mar",
        "name": "Marruecos"
    },
    {
        "alpha2": "mq",
        "alpha3": "mtq",
        "name": "Martinica",
        "inactive": true
    },
    {
        "alpha2": "mu",
        "alpha3": "mus",
        "name": "Mauricio"
    },
    {
        "alpha2": "mr",
        "alpha3": "mrt",
        "name": "Mauritania",
        "inactive": true
    },
    {
        "alpha2": "yt",
        "alpha3": "myt",
        "name": "Mayotte",
        "inactive": true
    },
    {
        "alpha2": "mx",
        "alpha3": "mex",
        "name": "Mexico"
    },
    {
        "alpha2": "fm",
        "alpha3": "fsm",
        "name": "Micronesia",
        "inactive": true
    },
    {
        "alpha2": "md",
        "alpha3": "mda",
        "name": "Moldavia"
    },
    {
        "alpha2": "mc",
        "alpha3": "mco",
        "name": "Monaco",
        "inactive": true
    },
    {
        "alpha2": "mn",
        "alpha3": "mng",
        "name": "Mongolia"
    },
    {
        "alpha2": "me",
        "alpha3": "mne",
        "name": "Montenegro"
    },
    {
        "alpha2": "ms",
        "alpha3": "msr",
        "name": "Montserrat",
        "inactive": true
    },
    {
        "alpha2": "mz",
        "alpha3": "moz",
        "name": "Mozambique"
    },
    {
        "alpha2": "mm",
        "alpha3": "mmr",
        "name": "Birmania",
        "inactive": true
    },
    {
        "alpha2": "na",
        "alpha3": "nam",
        "name": "Namibia",
        "inactive": true
    },
    {
        "alpha2": "nr",
        "alpha3": "nru",
        "name": "Nauru",
        "inactive": true
    },
    {
        "alpha2": "np",
        "alpha3": "npl",
        "name": "Nepal"
    },
    {
        "alpha2": "ni",
        "alpha3": "nic",
        "name": "Nicaragua"
    },
    {
        "alpha2": "ne",
        "alpha3": "ner",
        "name": "Niger"
    },
    {
        "alpha2": "ng",
        "alpha3": "nga",
        "name": "Nigeria"
    },
    {
        "alpha2": "nu",
        "alpha3": "niu",
        "name": "Niue",
        "inactive": true
    },
    {
        "alpha2": "nf",
        "alpha3": "nfk",
        "name": "Isla Norfolk",
        "inactive": true
    },
    {
        "alpha2": "no",
        "alpha3": "nor",
        "name": "Noruega"
    },
    {
        "alpha2": "nc",
        "alpha3": "ncl",
        "name": "Nueva Caledonia",
        "inactive": true
    },
    {
        "alpha2": "nz",
        "alpha3": "nzl",
        "name": "Nueva Zelanda"
    },
    {
        "alpha2": "om",
        "alpha3": "omn",
        "name": "Oman"
    },
    {
        "alpha2": "nl",
        "alpha3": "nld",
        "name": "Paises Bajos"
    },
    {
        "alpha2": "pk",
        "alpha3": "pak",
        "name": "Pakistan"
    },
    {
        "alpha2": "pw",
        "alpha3": "plw",
        "name": "Palaos",
        "inactive": true
    },
    {
        "alpha2": "ps",
        "alpha3": "pse",
        "name": "Palestina",
        "inactive": true
    },
    {
        "alpha2": "pa",
        "alpha3": "pan",
        "name": "Panama"
    },
    {
        "alpha2": "pg",
        "alpha3": "png",
        "name": "Papua Nueva Guinea",
        "inactive": true
    },
    {
        "alpha2": "py",
        "alpha3": "pry",
        "name": "Paraguay"
    },
    {
        "alpha2": "pe",
        "alpha3": "per",
        "name": "Peru"
    },
    {
        "alpha2": "pf",
        "alpha3": "pyf",
        "name": "Polinesia Francesa",
        "inactive": true
    },
    {
        "alpha2": "pl",
        "alpha3": "pol",
        "name": "Polonia"
    },
    {
        "alpha2": "pt",
        "alpha3": "prt",
        "name": "Portugal"
    },
    {
        "alpha2": "pr",
        "alpha3": "pri",
        "name": "Puerto Rico"
    },
    {
        "alpha2": "gb",
        "alpha3": "gbr",
        "name": "Reino Unido"
    },
    {
        "alpha2": "eh",
        "alpha3": "esh",
        "name": "Republica Arabe Saharaui Democratica",
        "inactive": true
    },
    {
        "alpha2": "cf",
        "alpha3": "caf",
        "name": "Republica Centroafricana"
    },
    {
        "alpha2": "cz",
        "alpha3": "cze",
        "name": "Republica Checa"
    },
    {
        "alpha2": "cg",
        "alpha3": "cog",
        "name": "Republica del Congo"
    },
    {
        "alpha2": "cd",
        "alpha3": "cod",
        "name": "Republica Democratica del Congo",
        "inactive": true
    },
    {
        "alpha2": "do",
        "alpha3": "dom",
        "name": "Republica Dominicana"
    },
    {
        "alpha2": "re",
        "alpha3": "reu",
        "name": "Reunion"
    },
    {
        "alpha2": "rw",
        "alpha3": "rwa",
        "name": "Ruanda"
    },
    {
        "alpha2": "ro",
        "alpha3": "rou",
        "name": "Rumania"
    },
    {
        "alpha2": "ru",
        "alpha3": "rus",
        "name": "Rusia",
        "inactive": true
    },
    {
        "alpha2": "ws",
        "alpha3": "wsm",
        "name": "Samoa",
        "inactive": true
    },
    {
        "alpha2": "as",
        "alpha3": "asm",
        "name": "Samoa Americana",
        "inactive": true
    },
    {
        "alpha2": "bl",
        "alpha3": "blm",
        "name": "San Bartolome",
        "inactive": true
    },
    {
        "alpha2": "kn",
        "alpha3": "kna",
        "name": "San Cristobal y Nieves"
    },
    {
        "alpha2": "sm",
        "alpha3": "smr",
        "name": "San Marino",
        "inactive": true
    },
    {
        "alpha2": "mf",
        "alpha3": "maf",
        "name": "San Martin",
        "inactive": true
    },
    {
        "alpha2": "pm",
        "alpha3": "spm",
        "name": "San Pedro y Miquelon",
        "inactive": true
    },
    {
        "alpha2": "vc",
        "alpha3": "vct",
        "name": "San Vicente y las Granadinas"
    },
    {
        "alpha2": "sh",
        "alpha3": "shn",
        "name": "Santa Elena Ascension y Tristan de Acuña",
        "inactive": true
    },
    {
        "alpha2": "lc",
        "alpha3": "lca",
        "name": "Santa Lucia"
    },
    {
        "alpha2": "st",
        "alpha3": "stp",
        "name": "Santo Tome y Principe",
        "inactive": true
    },
    {
        "alpha2": "sn",
        "alpha3": "sen",
        "name": "Senegal"
    },
    {
        "alpha2": "rs",
        "alpha3": "srb",
        "name": "Serbia"
    },
    {
        "alpha2": "sc",
        "alpha3": "syc",
        "name": "Seychelles"
    },
    {
        "alpha2": "sl",
        "alpha3": "sle",
        "name": "Sierra Leona",
        "inactive": true
    },
    {
        "alpha2": "sg",
        "alpha3": "sgp",
        "name": "Singapur"
    },
    {
        "alpha2": "sx",
        "alpha3": "sxm",
        "name": "San Martin",
        "inactive": true
    },
    {
        "alpha2": "sy",
        "alpha3": "syr",
        "name": "Siria",
        "inactive": true
    },
    {
        "alpha2": "so",
        "alpha3": "som",
        "name": "Somalia",
        "inactive": true
    },
    {
        "alpha2": "lk",
        "alpha3": "lka",
        "name": "Sri Lanka"
    },
    {
        "alpha2": "sz",
        "alpha3": "swz",
        "name": "Suazilandia"
    },
    {
        "alpha2": "za",
        "alpha3": "zaf",
        "name": "Sudafrica"
    },
    {
        "alpha2": "sd",
        "alpha3": "sdn",
        "name": "Sudan"
    },
    {
        "alpha2": "ss",
        "alpha3": "ssd",
        "name": "Sudan del Sur",
        "inactive": true
    },
    {
        "alpha2": "se",
        "alpha3": "swe",
        "name": "Suecia"
    },
    {
        "alpha2": "ch",
        "alpha3": "che",
        "name": "Suiza"
    },
    {
        "alpha2": "sr",
        "alpha3": "sur",
        "name": "Surinam"
    },
    {
        "alpha2": "sj",
        "alpha3": "sjm",
        "name": "Svalbard y Jan Mayen",
        "inactive": true
    },
    {
        "alpha2": "th",
        "alpha3": "tha",
        "name": "Tailandia"
    },
    {
        "alpha2": "tw",
        "alpha3": "twn",
        "name": "Taiwan Republica de China",
        "inactive": true
    },
    {
        "alpha2": "tz",
        "alpha3": "tza",
        "name": "Tanzania"
    },
    {
        "alpha2": "tj",
        "alpha3": "tjk",
        "name": "Tayikistan"
    },
    {
        "alpha2": "io",
        "alpha3": "iot",
        "name": "Territorio Britanico del Oceano Indico",
        "inactive": true
    },
    {
        "alpha2": "tf",
        "alpha3": "atf",
        "name": "Tierras Australes y Antarticas Francesas",
        "inactive": true
    },
    {
        "alpha2": "tl",
        "alpha3": "tls",
        "name": "Timor Oriental",
        "inactive": true
    },
    {
        "alpha2": "tg",
        "alpha3": "tgo",
        "name": "Togo",
        "inactive": true
    },
    {
        "alpha2": "tk",
        "alpha3": "tkl",
        "name": "Tokelau",
        "inactive": true
    },
    {
        "alpha2": "to",
        "alpha3": "ton",
        "name": "Tonga",
        "inactive": true
    },
    {
        "alpha2": "tt",
        "alpha3": "tto",
        "name": "Trinidad y Tobago"
    },
    {
        "alpha2": "tn",
        "alpha3": "tun",
        "name": "Tunez"
    },
    {
        "alpha2": "tm",
        "alpha3": "tkm",
        "name": "Turkmenistan",
        "inactive": true
    },
    {
        "alpha2": "tr",
        "alpha3": "tur",
        "name": "Turquia"
    },
    {
        "alpha2": "tv",
        "alpha3": "tuv",
        "name": "Tuvalu",
        "inactive": true
    },
    {
        "alpha2": "ua",
        "alpha3": "ukr",
        "name": "Ucrania"
    },
    {
        "alpha2": "ug",
        "alpha3": "uga",
        "name": "Uganda"
    },
    {
        "alpha2": "uy",
        "alpha3": "ury",
        "name": "Uruguay"
    },
    {
        "alpha2": "uz",
        "alpha3": "uzb",
        "name": "Uzbekistan"
    },
    {
        "alpha2": "vu",
        "alpha3": "vut",
        "name": "Vanuatu",
        "inactive": true
    },
    {
        "alpha2": "va",
        "alpha3": "vat",
        "name": "Vaticano Ciudad del",
        "inactive": true
    },
    {
        "alpha2": "ve",
        "alpha3": "ven",
        "name": "Venezuela",
        "inactive": true
    },
    {
        "alpha2": "vn",
        "alpha3": "vnm",
        "name": "Vietnam"
    },
    {
        "alpha2": "wf",
        "alpha3": "wlf",
        "name": "Wallis y Futuna",
        "inactive": true
    },
    {
        "alpha2": "ye",
        "alpha3": "yem",
        "name": "Yemen",
        "inactive": true
    },
    {
        "alpha2": "dj",
        "alpha3": "dji",
        "name": "Yibuti",
        "inactive": true
    },
    {
        "alpha2": "zm",
        "alpha3": "zmb",
        "name": "Zambia"
    },
    {
        "alpha2": "zw",
        "alpha3": "zwe",
        "name": "Zimbabue",
        "inactive": true
    }
]